import { render, staticRenderFns } from "./EventDetailsPage.vue?vue&type=template&id=182580ec&"
import script from "./EventDetailsPage.vue?vue&type=script&lang=js&"
export * from "./EventDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports